// src/pages/FAQ.js
import React, { useState } from 'react';
import './FAQ.css';
import filter14 from '../assets/Filters.png';
import markcorrect from '../assets/mark_as_correct.png';
import markapplied from '../assets/mark_as_applied.png';

const faqData = [
    {
      question: "1. What is Jobque.ai?",
      answer: "Jobque.ai is an AI-powered job search assistant. It monitors company career pages based on your search preferences and alerts you the moment a relevant job is posted — helping you apply early and beat the competition.",
      image: null,
    },
    {
      question: "2. How is Jobque.ai different from traditional job boards?",
      answer: "Unlike traditional job boards that show jobs already crowded with applicants, Jobque.ai monitors the source directly (the company's careers page) and alerts you before the opening gets heavily applied to.",
      image: null,
    },
    {
      question: "3. How does Jobque.ai find jobs?",
      answer: "You tell us what roles you're interested in and which companies you care about. Jobque.ai checks those companies' career pages at the frequency you set (hourly, daily, weekly) and notifies you when something matching appears.",
      image: null,
    },
    {
      question: "4. How quickly will I be notified of new jobs?",
      answer: "If you set an hourly check, you can be alerted within an hour of a job being posted on the company site — often before it shows up on job boards.",
      image: null,
    },
    {
      question: "5. Is there a limit to how many companies I can track?",
      answer: "Depending on your subscription plan, you can track a set number of companies. Higher-tier plans allow you to track more companies simultaneously.",
      image: null,
    },
    {
      question: "6. How do I give feedback about the accuracy of the search?",
      answer: "You can right-click a pill on the job search or dashboard page, and you will see the options 'Mark as incorrect result' or 'Mark as correct result.' This allows us to improve the algorithm and reduce false positives for your future searches.",
      image: markcorrect,
    },
    {
      question: "7. How do I stop getting emails after I have already applied?",
      answer: "When you apply for a job, right-click the pill and mark it. We'll stop sending you further emails about it, and your dashboard becomes your personal application tracker.",
      image: markapplied,
    },
    {
      question: "8. Will Jobque.ai apply to jobs for me automatically?",
      answer: "Not yet. Right now, Jobque.ai focuses on alerting you early. However, upcoming features will help pre-fill applications and auto-apply where possible.",
      image: null,
    },
    {
      question: "9. How accurate are Jobque.ai alerts?",
      answer: "We monitor official career pages directly, minimizing the risk of expired, fake, or duplicated postings. You get real-time updates from trusted sources.",
      image: null,
    },
    {
      question: "10. Is my personal information safe with Jobque.ai?",
      answer: "Absolutely. We use industry-standard encryption to protect your data and never sell your personal information to third parties. You’re in control of your data.",
      image: null,
    },
    {
      question: "11. How do I get started with Jobque.ai?",
      answer: "Sign up, set your job search criteria (positions, companies, location), select how often you want us to check, and you're ready to start receiving early alerts!",
      image: null,
    },
    {
      question: "12. How do I upgrade my Subscription?",
      answer: "You can upgrade to a higher plan with more job searches or downgrade to the free plan with 3 searches by visiting the 'Change Plan' option in your profile.",
      image: null,
    },
    {
      question: "13. How do I cancel my Subscription?",
      answer: "You can cancel your subscription anytime through the Stripe billing portal linked on your Jobque.ai profile page under 'Manage Plan'.",
      image: null,
    },
    {
        question: "14. How do I filter results on the Dashboard page?",
        answer: "Either you can filter by Match Type(exact, partial, or not found), by frequency(Hourly, Daily, Weekly), or by application status: Applied, Not Applied.",
        image: filter14,
      },

  ];

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="faq-page">
      <h1 className="faq-title">Frequently Asked Questions</h1>
      <div className="faq-container">
        {faqData.map((item, index) => (
          <div key={index} className="faq-item">
            <div
              className={`faq-question ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleAccordion(index)}
            >
              {item.question}
              <span className="arrow">{activeIndex === index ? '▲' : '▼'}</span>
            </div>
            <div
              className={`faq-answer ${activeIndex === index ? 'show' : ''}`}
            >
              <p>{item.answer}</p>
              {item.image && (
                <img src={item.image} alt="FAQ Illustration" className="faq-image" />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
